import styled from '@emotion/styled';
import { IcoSupportAgent, IcoVisibility } from '@myrealtrip/web-icons';

import DomainManager from '../../../shared/utils/DomainManager';
import { sendClickLog } from '../../utils/sendClickLog';
import { WeblogPageCategory, WeblogScreenName } from '../../../shared/constants/weblog';

import { getSigninWebLink } from '../../utils/getSigninWebLink';
import Button from '../../../shared/designSystem/components/Button';
import Icon from '../../../shared/designSystem/components/Icon';
import { globalVariables, S3_RESOURCE_LOGOS } from '../../../shared/designSystem/constants';

import SideBarLink from './SideBarLink';
import { getPartnerLink } from '../../utils/getPartnerLink';
import { useEnvContext } from '../../../modules/EnvProvider';
import { getTravelerLink } from '../../utils/getTravelerLink';

const baseLogData = {
  screenName: WeblogScreenName.COMMON,
  pageCategory: WeblogPageCategory.COMMON,
};

const ICON_SIZE = 24;

export default function LoggedOutItems() {
  const { targetEnv } = useEnvContext();
  const domainManager = new DomainManager(targetEnv);
  const supportDomain = domainManager.getSupportDomain();

  const handleClickSupport = () => {
    sendClickLog({
      ...baseLogData,
      eventName: 'topmenu',
      itemKind: 'menu',
      itemName: '고객지원실',
      targetUrl: supportDomain,
    });

    location.href = supportDomain;
  };

  const handleClickLogo = () => {
    sendClickLog({
      ...baseLogData,
      eventName: 'mainLogo',
    });
  };
  const handleClickSignInUp = () => {
    const targetUrl = getSigninWebLink(targetEnv);

    sendClickLog({
      ...baseLogData,
      eventName: 'topmenu',
      itemKind: 'menu',
      itemName: '로그인 및 회원가입',
      targetUrl,
    });

    window.location.href = targetUrl;
  };

  return (
    <Container>
      <MrtLogoSection>
        <MrtLogoAnchor href={domainManager.getTravelerServiceDomain()} onClick={handleClickLogo}>
          <MrtLogoImage baseUrl={S3_RESOURCE_LOGOS} name="logo_mrt_v2_web" />
        </MrtLogoAnchor>
      </MrtLogoSection>
      <ButtonSection>
        <SignInUpButton type="primary" size="large" onClick={handleClickSignInUp}>
          로그인 및 회원가입
        </SignInUpButton>
      </ButtonSection>
      <Section>
        <SideBarLink
          label="최근 본 상품"
          icon={<IcoVisibility size={ICON_SIZE} />}
          link={getTravelerLink(
            '/search/theme?themeKeyName=recentViewProduct&seemorePage=seemore_mypage_recent&apiType=user',
            targetEnv,
          )}
        />
        <SideBarLink
          label="고객지원실"
          icon={<IcoSupportAgent size={ICON_SIZE} />}
          onClick={handleClickSupport}
        />
      </Section>
      <Section noBorder>
        <SideBarLink
          label="파트너 로그인"
          link={getPartnerLink('/signIn', targetEnv)}
          alignCenter
        />
      </Section>
    </Container>
  );
}

const Container = styled.div``;

const Section = styled.div<{ noBorder?: boolean }>`
  padding: 20px 16px;
  border-bottom: ${({ noBorder }) => (noBorder ? '0' : `1px solid ${globalVariables.gray_100}`)};
`;

const MrtLogoSection = styled.div`
  padding: 24px 0;
`;
const MrtLogoAnchor = styled.a`
  display: block;
`;
const MrtLogoImage = styled(Icon)`
  width: 100%;
  height: 30px;
`;

const ButtonSection = styled.div`
  padding: 0 16px 20px;
  border-bottom: 1px solid ${globalVariables.gray_100};
`;
const SignInUpButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 48px;

  & > button {
    background: var(--blue-500);
    width: 100%;
    padding: 0;
    border-radius: 12px;
  }

  &:not(:last-of-type) {
    margin-bottom: 8px;
  }
`;
